// extracted by mini-css-extract-plugin
export default {"opening-hours-item":"OpeningHoursItem_opening-hours-item__rge1u","day":"OpeningHoursItem_day__aNv3S","time":"OpeningHoursItem_time__mVAkR"};